import React, {useState} from "react"
import DayTimeSelect from "../DayTimeSelect"
import {DAY_TIME_HOUR_LIST} from "../../constants/datetime"
import styles from "./TimeIntervalPicker.module.css"
import {intervalTimeChangeIsValid} from "../../utils/datetimeUtils"

import { Switch } from "@mui/material";
const TimeIntervalPicker = ({timeInterval={fromTime: "00:00", toTime: "01:00"}, onChange=()=>{}}) => {
    let {fromTime, toTime} = timeInterval
    const [crossesMidnight, setCrossesMidnight] = useState(toTime < fromTime)
    const [errorHighlight, setErrorHighlight] = useState(false)
    const highlightError = () => {
        setErrorHighlight(true)
        setTimeout(() => setErrorHighlight(false), 1000)
    }

    const handleTimeIntervalChange = (e, key) => {
        const newTime = e.target.value
        const isFromTime = key === "fromTime"
        const otherTime = isFromTime ? toTime : fromTime
        if (intervalTimeChangeIsValid(newTime, isFromTime, otherTime, crossesMidnight)){
            //once the interval remains valid, update the parent with the new interval
            if (isFromTime) onChange({fromTime: newTime, toTime})
            else onChange({fromTime, toTime: newTime})
        } else {
            highlightError()
            return
        }  
    }

    const toggleCrossesMidnight = crossesMidnight => {
        setCrossesMidnight(crossesMidnight)
        if (!crossesMidnight && toTime < fromTime) {
            const lastTime = DAY_TIME_HOUR_LIST[DAY_TIME_HOUR_LIST.length - 1].id
            onChange({fromTime, toTime: lastTime})
        }
    }
    return (
        <div>
            <div className={`${styles.container} ${errorHighlight ? "errorShake" : ""}`}>
                <DayTimeSelect
                    value={fromTime}
                    onChange={e => handleTimeIntervalChange(e, "fromTime")}
                />
                <div>to</div>
                <DayTimeSelect
                    value={toTime}
                    onChange={e => handleTimeIntervalChange(e, "toTime")}
                />
            </div>
            <div className="label display-flex justify-content-flex-end align-items-center">
                
                <div className="font-size-10px font-weight-600">
                    {crossesMidnight? "Pass 12 midnight" : "Don't pass 12 midnight"} 
                </div>
                <Switch 
                    checked={crossesMidnight}
                    color="success"
                    onChange={() => toggleCrossesMidnight(!crossesMidnight)}
                />
            </div>
        </div>

    )
}

export default TimeIntervalPicker